<template>
  <v-form autocomplete="off" ref="contact-form" @submit.prevent="submit" lazy-validation>
    <v-card>
      <v-card-text>
        <v-text-field :disabled="submitted" :color="$config.colors.lighter" :rules="value" browser-autocomplete="off" prepend-icon="mdi-account" :label="$lang.name" required v-model="postData.name" />
        <v-text-field :disabled="submitted" :color="$config.colors.lighter" :rules="email" browser-autocomplete="off" prepend-icon="mdi-email" :label="$lang.email" required v-model="postData.email" />
        <v-textarea :disabled="submitted" :color="$config.colors.lighter" :rules="value" browser-autocomplete="off" prepend-icon="mdi-message-text" no-resize :label="$lang.message" required v-model="postData.message" />
        <v-alert type="success" :value="success">{{ $lang.messageSent }}</v-alert>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn :loading="submitting" :disabled="submitted" type="submit" :title="$lang.submit" aria-label="submit-contact-form" :color="$config.colors.primary">{{ $lang.submit }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>
<script>
import methods from '../mixins/methods'
import email from '../helpers/rules-email'
import value from '../helpers/rules-value'

export default {
  name: 'ContactForm',
  mixins: [
    methods
  ],
  data () {
    return {
      email,
      value,
      success: null,
      submitting: false,
      submitted: false,
      postData: {
        name: '',
        email: '',
        message: ''
      }
    }
  },
  methods: {
    reset () {
      this.$refs['contact-form'].reset()
    },
    submit () {
      if (this.$refs['contact-form'].validate()) {
        this.submitting = true
        this.$http({
          url: this.getRoute('contact').url,
          data: this.postData,
          method: 'POST'
        }).then(() => {
          this.success = this.$lang.messageSent
          this.submitting = false
          this.submitted = true
          this.reset()
        }).catch(error => {
          this.submitting = false
          this.submitted = true
          console.error(error)
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/contact-form.vue